module.exports = __webpack_public_path__ + "img/message.f321d93c.svg";